import React from "react";

const DashboardIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>dashboard-icon</title>
      <path
        d="M8 16c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zM8 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 8c-.905.003-1.698-.603-1.932-1.477-.235-.873.148-1.795.932-2.246V4c0-.552.448-1 1-1s1 .448 1 1v2.277c.784.45 1.167 1.373.932 2.246C9.698 9.397 8.905 10.003 8 10z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};
export default DashboardIcon;
